import React, { Component } from 'react';
import { Modal, Button } from 'antd';

export class SuccessContractInsert extends Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: false
        }
    }

    changeVisible = (visible, contractCode, addVehicle, addNewContract, goToContractList) => this.setState({ visible, contractCode, addVehicle, addNewContract, goToContractList });

    render() {
        const { visible, contractCode, addVehicle, addNewContract, goToContractList } = this.state;

        return (
            <Modal
                title="Thêm hợp đồng thành công"
                className="logout-modal"
                visible={visible}
                closable={false}
                footer={[
                    <Button key="add-vehicle" className="add-vehicle" onClick={() => {
                        this.changeVisible(false)
                        addVehicle();
                    }}>Thêm xe cho hợp đồng vừa tạo</Button>,
                    <Button key="add-new" className="add-new" onClick={() => {
                        this.changeVisible(false);
                        addNewContract();
                    }}>Thêm HĐ mới</Button>,
                    <Button key="go-to-list" className="go-to-list" onClick={() => {
                        this.changeVisible(false);
                        goToContractList();
                    }}>Danh sách HĐ</Button>,
                ]}
            >
                <p style={{ textAlign: 'center' }}>Thêm hợp đồng {contractCode} thành công. Bạn có muốn?</p>
            </Modal>
        )
    }
}
